import { loanDetailsData } from "configs/loanDetails.config";
import { opportunityData } from "configs/opportunity.config";
import cloneDeep from "lodash.clonedeep";
import {
  DatePicker,
  Dropdown,
  FilePicker,
  GroupRenderer,
  Input,
  Textarea,
} from "stories";
import { getPrincipalModel } from "../../partners/principals/Principals";
import {
  getCurrentProjectModal,
  getProjectModal,
} from "../../partners/projects/Projects";

export const numberValueTransformer = (v) => Number(parseFloat(v));
const projectFields = [
  [
    {
      name: "name",
      component: Input,
      props: {
        label: "Project Name",
      },
    },
    {
      name: "address",
      component: Input,
      props: {
        label: "Address",
      },
    },
  ],
  [
    {
      name: "asset_class",
      component: Dropdown,
      props: {
        label: "Asset Class",
        list: opportunityData.assetTypeList,
      },
    },
    {
      name: "completion_date",
      component: DatePicker,
      props: {
        label: "Completion Date",
      },
    },
  ],
  [
    {
      name: "description",
      component: Textarea,
      props: {
        label: "Description",
      },
    },
  ],
  [
    {
      name: "website",
      component: Input,
      props: {
        label: "Website",
      },
    },
    {},
  ],
];

export const completedProjectFields = {
  name: "completed_projects",
  renderAsFormItem: false,
  component: GroupRenderer,
  props: {
    title: "Completed Projects",
    itemPrefix: "Completed Project",
    addButtonText: "Add One More Project",
    fields: projectFields,
    getModelItem: getProjectModal,
  },
};

const cProjectFields = cloneDeep(projectFields);
cProjectFields[1][1].props.label = "Expected Completion Date";
cProjectFields[1][1].name = "expected_completion_date";
export const currentProjectFields = {
  name: "current_projects",
  renderAsFormItem: false,
  component: GroupRenderer,
  props: {
    title: "Current Projects",
    itemPrefix: "Current Project",
    addButtonText: "Add One More Project",
    fields: cProjectFields,
    getModelItem: getCurrentProjectModal,
  },
};

export const corporationFields = [
  [
    {
      name: "corporate_structure",
      component: Dropdown,
      props: {
        label: "Corporate Structure",
        list: loanDetailsData.corporationTypeList,
      },
    },
    {
      name: "corporation_name",
      component: Input,
      props: {
        label: "Corporation Name",
      },
    },
  ],
  [
    {
      name: "incorporation_document_filename",
      component: FilePicker,
      props: {
        label: "Incorporation Documents",
        multiple: false,
        type: "file",
      },
    },
    {},
  ],
  [
    {
      name: "corporate_share_register_filename",
      component: FilePicker,
      props: {
        label: "Corporate Share Registrar",
        multiple: false,
        type: "file",
      },
    },
    {},
  ],
  [
    {
      name: "website",
      component: Input,
      props: {
        label: "Website",
      },
    },
    {
      name: "industry",
      component: Input,
      props: {
        label: "Industry",
      },
    },
  ],
  [
    {
      name: "biography",
      component: Textarea,
      props: {
        label: "Biography",
      },
    },
  ],
  [
    {
      name: "hq_address",
      component: Input,
      props: {
        label: "HQ Address",
      },
    },
  ],
  [
    {
      name: "corporate_net_asset_value",
      component: Input,
      props: {
        label: "Corporate Net Asset Value",
        type: "currency",
        startAdornment: "$",
      },
    },
    {},
  ],
  [
    {
      name: "financial_statement_filename",
      component: FilePicker,
      props: {
        label: "Financial Statements",
        type: "file",
      },
    },
    {},
  ],
  [
    {
      name: "principals",
      renderAsFormItem: false,
      component: GroupRenderer,
      props: {
        name: "principals",
        title: "Principals",
        itemPrefix: "Principal",
        addButtonText: "Add One More Principal",
        fields: [
          [
            {
              name: "name",
              component: Input,
              props: {
                label: "Full Name",
              },
            },
            {
              name: "position",
              component: Input,
              props: {
                label: "Position",
              },
            },
          ],
          [
            {
              name: "notes",
              component: Textarea,
              props: {
                label: "Notes",
              },
            },
          ],
          [
            {
              name: "share_of_corporation",
              component: Input,
              valueTransformer: numberValueTransformer,
              props: {
                label: "% Ownership of Corporation",
                type: "number",
              },
            },
            {
              name: "personal_net_worth",
              component: Input,
              props: {
                label: "Personal Net-Worth",
                type: "currency",
                startAdornment: "$",
              },
            },
          ],
          [
            {
              name: "net_worth_document_filename",
              component: FilePicker,
              props: {
                label: "Net Worth Documentation",
                type: "file",
              },
            },
            {},
          ],
        ],
        getModelItem: getPrincipalModel,
      },
    },
  ],
  [completedProjectFields],
  [currentProjectFields],
];
